import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { SiteAction } from '../../actions/SiteAction';
import { RayForm, RayFormValidation } from '../../components/common';
import { history } from '../../history';
import { SpecialityTypes } from '../../config/RayCodes';
import { CountryCode } from '../../config';
import { Translate as t } from '../../config/Translate';

const AdminSiteAdd = ({ site, AddSite }) => {

    const [isAddProcess, setIsAddProcess] = useState(false);
    const [errors, setErrors] = useState([]);
    const [newsite, setNewSite] = useState({
        speciality: SpecialityTypes[0].code,
        country: CountryCode[0].code
    });

    useEffect(() => {
        if (isAddProcess) {
            history.push("/Admin/AdminSiteList");
        }
    }, [site])

    const handleChangeData = (e) => {
        const { name, value } = e.target;
        setNewSite({ ...newsite, [name]: value });
    }

    const form_controls = [
        {
            title: t('site.label.siteInformation'), items: [
                { type: "input", name: "sitename", label: t('site.field.siteName'), val: newsite.sitename, required: true },
                { type: "select", name: "speciality", label: t('site.field.specialty'), val: newsite.speciality, list: SpecialityTypes }
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "tel", label: t('common.field.tel'), val: newsite.tel },
                { type: "tel", name: "fax", label: t('common.field.fax'), val: newsite.fax }
            ]
        },
        {
            title: "", items: [
                { type: "email", name: "email", label: t('common.field.email'), val: newsite.email },
                { type: "tel", name: "hp", label: t('common.field.mobile'), val: newsite.hp }
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "address", label: t('common.field.address'), size: 12, val: newsite.address },
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "addressExtra", label: t('common.field.addressExtra'), size: 12, val: newsite.addressExtra }
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "zipcode", label: t('common.field.zipCode'), val: newsite.zipcode },
                { type: "select", name: "country", label: t('common.field.country'), val: newsite.country, list: CountryCode }
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "website", label: t('common.field.website'), val: newsite.website, size: 12 }
            ]
        },
        {
            title: t('common.label.customerInformation'), items: [
                { type: "input", name: "customerFirstName", label: t('common.field.firstName'), val: newsite.customerFirstName },
                { type: "input", name: "customerLastName", label: t('common.field.lastName'), val: newsite.customerLastName }
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "customerHp", label: t('common.field.customerMobile'), val: newsite.customerHp },
                { type: "email", name: "customerEmail", label: t('common.field.customerEmail'), val: newsite.customerEmail }
            ]
        }
    ]

    const validAdd = () => {
        const errValidate = RayFormValidation(form_controls, newsite);
        if (errValidate.length > 0) {
            setErrors(errValidate);
        } else {
            setIsAddProcess(true);
            AddSite(newsite);
        }
    }

    return (
        <>
            <div className="extraHeader">
                <h2 className="mb-0">{t('site.button.addNewSite')}</h2>
                <div className="ray-right">
                    <Link to="/Admin/AdminSiteList" className="btn btn-outline-default btn-sm mt-0 me-1">{t('common.label.list')}</Link>
                </div>
            </div>
            <div id="appCapsule" className="extra-header-active full-height">
                <RayForm
                    controls={form_controls}
                    isForm={true}
                    handleChangeData={handleChangeData}
                    errors={errors} />
                <div className="section">
                    <button className="btn btn-primary" onClick={() => validAdd()}>{t('common.button.add')}</button>
                </div>
            </div>
        </>
    );
};

const mapState = (state) => {
    const site = state.SiteReducer.site;
    return { site };
}

const mapDispatch = dispatch => ({
    AddSite: (site) => dispatch(SiteAction.AddSite(site)),
})
export default connect(mapState, mapDispatch)(AdminSiteAdd);